/**
 * Stripe の card brand 値（`visa` / `mastercard` 等）に対応する日本語表示名。
 *
 * @see https://docs.stripe.com/api/cards/object#card_object-brand
 */
export const CARD_BRAND_LABELS: Record<string, string> = {
  visa: 'ビザ',
  mastercard: 'マスターカード',
  amex: 'アメリカン・エキスプレス',
  jcb: 'JCB',
  diners: 'ダイナースクラブ',
  discover: 'ディスカバー',
  unionpay: '銀聯',
};
